// Utility functions for demo mode detection and management
import userStore from '../stores/UserStore';

/**
 * Check if the current user is a demo user
 */
export const isDemoMode = (): boolean => {
  return userStore.user?.userId === 'demo-user';
};

/**
 * Get the demo project ID if in demo mode
 */
export const getDemoProjectId = (): string | null => {
  if (!isDemoMode()) return null;
  return userStore.user?.projectAdminAccess?.[0] || null;
};

/**
 * Clear all demo data from localStorage
 */
export const clearDemoData = (): void => {
  const keys = Object.keys(localStorage);
  keys.forEach(key => {
    if (key.startsWith('demo_')) {
      localStorage.removeItem(key);
    }
  });
};

